import React, { PureComponent } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

class ConfigurationItem extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    title: PropTypes.oneOfType([PropTypes.node, PropTypes.element]),
    description: PropTypes.oneOfType([PropTypes.node, PropTypes.element]),
    trailing: PropTypes.oneOfType([PropTypes.node, PropTypes.element])
  };

  get classes() {
    const { className, disabled } = this.props;

    return classNames(
      'ca-configuration__item',
      { 'ca-configuration__item--disabled': disabled },
      '_mt-5',
      className
    );
  }

  render() {
    const { title, description, trailing, children } = this.props;

    return (
      <article className={this.classes}>
        {title && (
          <header className="_text-gray-800 _line-height-lg _mt-0 _mr-0 _mb-2 _ml-0">
            {title}
          </header>
        )}
        {(description || trailing) && (
          <div className="_d-flex _flex-column _flex-md-row _justify-content-between _m-0">
            <div className="_line-height-lg _text-left _text-gray-400 _m-0 _p-0">
              {description}
            </div>
            {trailing && (
              <div className="_text-left _mt-4 _mt-md-0 _mr-0 _mb-0 _ml-0 _ml-md-5 _pr-md-5">
                {trailing}
              </div>
            )}
          </div>
        )}
        {children && <div className="_mt-5">{children}</div>}
      </article>
    );
  }
}

export default ConfigurationItem;
